import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
// NOTE: Mapbox telemetry is NO LONGER disabled from here. The old
// side-effect import ran at bootstrap, which put `mapbox-gl` in the entry
// import graph and made Vite `modulepreload` the entire map library on every
// page load — login included. `disableMapboxTelemetry()` is now called by each
// map-creating component instead (Dispatcher/Map/MapView.tsx,
// Scheduler/dialogs/AddressLookupDialog.tsx). Any new map site must call it.
import 'react-datepicker/dist/react-datepicker.css';
// Self-hosted fonts. Shipped via @fontsource/* so no runtime Google Fonts
// fetch — required for GDPR compliance (2022 Munich ruling: dynamic Google
// Fonts without consent violates GDPR for EU operators). Vite resolves the
// woff2 paths through its asset pipeline and ships hashed, same-origin files.
//
// ⚠️ IMPORT THE SUBSET, NOT THE BARE WEIGHT. `@fontsource/inter/400.css`
// pulls SEVEN @font-face rules (latin, latin-ext, cyrillic, cyrillic-ext,
// greek, greek-ext, vietnamese); `latin-400.css` + `latin-ext-400.css` pull
// two. The extra rules are parsed on every page load and their files are
// built into dist, for scripts a DE/EN admin panel never renders.
//
// We keep latin AND latin-ext: latin alone covers German (ä ö ü ß), but
// latin-ext carries the Polish / Czech / Turkish / Hungarian letters that
// appear in real patient and driver names. Dropping it would silently fall
// those names back to a system font mid-word.
//
// Cormorant Garamond and Geist Mono were removed 2026-09-04 — their only
// consumer was the dead `.login-atmospheric` block in index.css.
// Geist Sans ships a latin subset only, so its plain weights are already
// minimal and need no `latin-` prefix.
import '@fontsource/geist-sans/300.css';
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
// Inter is the base UI font for the default "navy" theme. Weights mirror the
// `--font-sans` stack in src/index.css — keep this list in sync.
import '@fontsource/inter/latin-300.css';
import '@fontsource/inter/latin-ext-300.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-ext-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-ext-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-ext-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/latin-ext-700.css';
// Bryntum CSS is imported lazily inside components/Scheduler/index.tsx so it
// only ships when the user actually visits the /scheduler route.
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
